import { Component, OnInit, ViewChild, QueryList, AfterViewInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IssuesRest } from '../../issues.rest';
import { IssueHeaderComponent } from '../issue-header/issue-header.component';
import { Issue } from '../../issues.model';
import { MenuButton } from '../../../core/shared/tabmenu/tabmenu.model';
import { MatTabChangeEvent } from '@angular/material';
import { IssueElementsComponent } from '../issue-elements/issue-elements.component';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';
import { RichTextComponent } from '../../../core/shared/richtext/richtext.component';
import { LoginRest } from '../../../login/login.rest';
import { IssueRelationsComponent } from '../issue-relations/issue-relations.component';
import { IssueWorklogsComponent } from '../issue-worklogs/issue-worklogs.component';
import { AttachmentsComponent } from '../../../core/shared/attachments/attachments.component';
import { SpinnerService } from '../../../core/services/spinner-handler/spinner-handler.service';
import { GridParamsRestoringService } from '../../../core/services/grid-params-restoring/grid-params-restoring.service';
import { IssueService } from '../../issue.service';
import { AttachmentRest } from '../../../core/shared/attachments/attachments.rest';
import { EmployeesRest } from '../../../company/employees/employee.rest';

@Component({
  selector: 'app-issue-details',
  templateUrl: './issue-details.component.html',
  styleUrls: ['./issue-details.component.scss']
})
export class IssueDetailsComponent implements OnInit, HasPermissions, AfterViewInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private rest: IssuesRest,
    private loginRest: LoginRest,
    private permissionsService: PermissionsService,
    private spinnerService: SpinnerService,
    private issueService: IssueService,
    private gridParamsRestoringService: GridParamsRestoringService,
    private attachmentRest: AttachmentRest,
    private employeeRest: EmployeesRest) { }

  @ViewChild(IssueHeaderComponent) issueHeaderComponent: IssueHeaderComponent;
  @ViewChild(IssueElementsComponent) issueElementsComponent: IssueElementsComponent;
  @ViewChild(IssueRelationsComponent) issueRelationsComponent: IssueRelationsComponent;
  @ViewChild(IssueWorklogsComponent) issueWorklogsComponent: IssueWorklogsComponent;
  @ViewChild(AttachmentsComponent) attachmentsComponent: AttachmentsComponent;

  public issue: Issue;
  public isNew: boolean;
  public employeeId: number;
  public selectedTab = 1;
  public isCopy = false;
  private isSaving = false;

  private menuButtons: MenuButton[] = [
    { text: 'COMMONBUTTONS_save', class: "btn-success", icon: '', onClick: () => { this.save(); }, enabled: false, isForSelected: false },
    { text: 'COMMONBUTTONS_close', class: "btn-danger", icon: '', onClick: () => { this.close(); }, enabled: true, isForSelected: false }
  ];
  private saveButton = { text: 'COMMONBUTTONS_save', class: "btn-success", icon: '', onClick: () => { this.save(); }, enabled: false, isForSelected: false };

  permissions: Permissions;
  setPermissions(claimType: string): void {
    this.permissions = this.permissionsService.getUserPermissions(claimType);
  }

  ngOnInit() {
    this.spinnerService.show();
    this.setPermissions('Issue');

    if (this.permissions.canAdd || this.permissions.canEdit) {
      this.menuButtons.find(x => x.text === 'COMMONBUTTONS_save').enabled = true;
      this.saveButton.enabled = true;
    }

    if (!this.issueHeaderComponent.headerDescriptionViews) {
      this.issueHeaderComponent.headerDescriptionViews = null;
    }

    this.route.queryParams.subscribe(params => {
      if (params.isCopy) {
        this.isCopy = params.isCopy;
        this.rest.copyIssue(params.id).subscribe(issue => {
          this.isNew = true;
          this.issue = issue;
          this.issue.htmlDescripiton = null;
          this.issueHeaderComponent.setModel(this.issue, this.isNew);
          this.spinnerService.hide();
        });
      } else {
        this.issueService.currentIssue.subscribe((currentIssue: Issue) => {
          if (params.id) {
            this.spinnerService.show();
            if (currentIssue && (currentIssue.id.toString() === params.id)) {
              this.isNew = params.id === '0' ? true : false;
              this.issue = currentIssue;
              this.issueHeaderComponent.saveDescription();
              this.issueHeaderComponent.setModel(this.issue, this.isNew);
              this.spinnerService.hide();
            } else {
              if (params.id === '0') {
                this.isNew = true;
                this.loginRest.GetLoggedUser().subscribe(result => {
                  this.rest.createEmptyIssue(result.employeeId).subscribe(issue => {
                    this.issue = issue;
                    this.issueHeaderComponent.saveDescription();
                    this.issueHeaderComponent.setModel(this.issue, this.isNew);
                    this.spinnerService.hide();
                  });
                });
              } else {
                this.isNew = false;
                this.rest.getIssue(params.id).subscribe(issue => {
                  this.issue = issue;
                  this.issueHeaderComponent.saveDescription();
                  this.issueHeaderComponent.setModel(this.issue, this.isNew);
                  this.spinnerService.hide();
                });
              }
            }
          }
        }).unsubscribe();
      }
      this.issueService.currentTab.subscribe((tabIndex: number) => {
        if (tabIndex && tabIndex !== 0) {
          this.selectedTab = tabIndex;
          if (this.selectedTab === 5) {
            this.issueWorklogsComponent.setModel(this.issue.worklogs, this.issue, this.permissions.canEdit);
          }
        }
      }).unsubscribe();
    });
  }

  ngAfterViewInit() {
    this.spinnerService.hide();
  }

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.issueElementsComponent != null && this.issueElementsComponent.elementModal != null
      && this.issueElementsComponent.elementModal.modal.modalRoot.isShown === true) {
      return;
    }
    this.save();
    event.preventDefault();
  }

  public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    if (tabChangeEvent.index === 1) {
      if (this.issue.issueElements) {
        const lastElement = this.issue.issueElements.sort((a, b) => new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime())[this.issue.issueElements.length - 1];
        if (lastElement) {
          this.issue.objectStateId = lastElement.objectStateId;
          this.issue.elementAssignee = lastElement.employeeFullName;
        }
      }
      this.issueHeaderComponent.getDescription();
    }
    if (tabChangeEvent.index === 2) {
      let assigneeName = '';
      if (this.issue.assigneeId && this.issue.assigneeId !== 0) {
        let assignee = this.issueHeaderComponent.employees.find(x => x.id === this.issue.assigneeId);

        if (assignee == null) {
          this.employeeRest.getEmployee(this.issue.assigneeId).subscribe(empl => assigneeName = empl.fullName)
        } else {
          assigneeName = assignee.name;
        }
      }

      if (this.issue.issueElements == undefined || this.issue.issueElements.some(x => x.autoForNotAssigned)) {
        this.spinnerService.show();
        let autoForNotAssignedElement = null;
        if (this.issue.issueElements && this.issue.issueElements.some(x => x.autoForNotAssigned)) {
          autoForNotAssignedElement = this.issue.issueElements.find(x => x.autoForNotAssigned);
        }
        this.rest.getIssueElements(this.issue.id).subscribe(issueElements => {
          this.issue.issueElements = issueElements;
          if (autoForNotAssignedElement) {
            this.issue.issueElements.push(autoForNotAssignedElement);
          }
          this.issueElementsComponent.setModel(this.issue, assigneeName, this.isNew);
          this.spinnerService.hide();
        });
      } else {
        this.issueElementsComponent.setModel(this.issue, assigneeName, this.isNew);
      }
    }
    if (tabChangeEvent.index === 3) {
      if (!this.issue.attachments || this.issue.attachments.length === 0) {
        let path = `api/issues/attachments/grid/${this.issue.objectTypeId}/${this.issue.id}`;
        this.attachmentRest.getAttachmentsGrid(path).subscribe(res => {
          this.issue.attachments = res;
          this.attachmentsComponent.setModel(this.issue, 'issues');
        });
      }
      else {
        this.attachmentsComponent.setModel(this.issue, 'issues');
      }
    }
    if (tabChangeEvent.index === 4) {
      if (this.issue.issueRelations == undefined) {
        this.spinnerService.show();
        this.rest.getIssueRelations(this.issue.id).subscribe(issueRelations => {
          this.issue.issueRelations = issueRelations;
          this.issueRelationsComponent.setModel(this.issue.issueRelations, this.permissions.canEdit, this.issue.id, this.isNew);
          this.spinnerService.hide();
        });
      } else {
        this.issueRelationsComponent.setModel(this.issue.issueRelations, this.permissions.canEdit, this.issue.id, this.isNew);
      }
    }
    if (tabChangeEvent.index === 5) {
      if (this.issue.worklogs == undefined) {
        this.spinnerService.show();
        this.rest.getIssueWorklogs(this.issue.id).subscribe(issueWorklogs => {
          this.issue.worklogs = issueWorklogs;
          this.issueWorklogsComponent.setModel(this.issue.worklogs, this.issue, this.permissions.canEdit);
          this.spinnerService.hide();
        });
      } else {
        this.issueWorklogsComponent.setModel(this.issue.worklogs, this.issue, this.permissions.canEdit);
      }
    }

    this.issueHeaderComponent.saveDescription();
  }

  private save() {
    if (this.isNew && (this.issue.issueElements == undefined || this.issue.issueElements.length == 0)) {
      sweetAlert(`Brak elementów na zgłoszeniu. Proszę wprowadzić element.`);
      return;
    }

    this.issueHeaderComponent.saveDescription();
    if (this.issueHeaderComponent.isInvalid()) {
      sweetAlert(`Uzupełnij wymagane pola na nagłówku`);
      return;
    }

    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    this.spinnerService.show();
    if (!this.issue.systemVersionId) {
      const action = this.rest.getEmptySystemVersion;
      action.call(this.rest).subscribe((result: number) => {
        if (result) {
          this.issue.systemVersionId = result;
          this.saveIssue();
        }
      });
    } else {
      this.saveIssue();
    }
  }

  private saveIssue() {
    const action = this.rest.saveIssue;
    action.call(this.rest, this.issue, this.isNew).subscribe((result: Issue) => {
      if (this.isNew) {
        this.gridParamsRestoringService.saveAddingNewRowInfo(result.id);
      }
      this.isSaving = false;
      this.close();
    }, (error) => {
      this.isSaving = false;
    });
  }

  private close() {
    this.issueHeaderComponent.headerDescriptionViews = null;
    this.issueService.complete();
    let pathToReturn = '../../';
    if (this.isCopy) {
      pathToReturn = '../../../';
    }
    this.router.navigate([pathToReturn], { relativeTo: this.route });
    this.spinnerService.hide();
  }
}
